<!-- ============================================================== -->
<!-- Left Sidebar - style you can find in sidebar.scss  -->
<!-- ============================================================== -->
<aside class="left-sidebar">
    <!-- Sidebar scroll-->
    <div class="scroll-sidebar">
        <!-- Sidebar navigation-->
        <nav class="sidebar-nav">
            <ul id="sidebarnav">
                <li class="user-profile">
                    <a class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false"><img src="../assets/images/users/usuario.png" alt="user" /><span class="hide-menu">{{usuarioNombre + ' ' + usuarioApellido}} </span></a>
                    <ul aria-expanded="false" class="collapse">
                        <!--<li><a (click)="usuarioService.logout()" class="pointer">Salir</a></li>-->
                    </ul>
                </li>
                <li class="nav-devider"></li>
                <li class="nav-small-cap">MENU</li>

                <ng-container>
                    <li *ngFor="let menu of sidebar.menu">
                        <a class="has-arrow waves-effect waves-dark" aria-expanded="false"><i [class]="menu.icono"></i><span class="hide-menu">{{ menu.titulo }} <span class="label label-rouded label-themecolor pull-right"> {{ menu.submenu.length }}</span></span></a>
                        <ul aria-expanded="false" class="collapse">
                            <li *ngFor="let submenu of menu.submenu"><a routerLinkActive="active"> {{ submenu.titulo }} </a></li>

                        </ul>
                    </li>
                </ng-container>
            </ul>
        </nav>
        <!-- End Sidebar navigation -->
    </div>
    <!-- End Sidebar scroll-->
</aside>
<!-- ============================================================== -->
<!-- End Left Sidebar - style you can find in sidebar.scss  -->
<!-- ============================================================== -->
